module.exports = __webpack_public_path__ + "img/collection-memoireRingsAsWeddingRings@2x.d5cf011.webp";